import { useEffect } from "react";
const useUnsafeEffect = (effect, deps) => {
  useEffect(() => {
    try {
      return effect();
    } catch (error) {
      console.error(error);
    }
  }, deps);
};
export {
  useUnsafeEffect as default
};
